import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICompanyListState } from '../states/company-list.state';

export const selectCompanyListState = createFeatureSelector<ICompanyListState>('companyList');

export const selectCompanySearchFilter = createSelector(
  selectCompanyListState,
  (state: ICompanyListState) => state.searchFilter
);

export const selectCompanyPagination = createSelector(
  selectCompanyListState,
  (state: ICompanyListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectCompanySort = createSelector(
  selectCompanyListState,
  (state: ICompanyListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectCompanyListFullState = createSelector(
  selectCompanyListState,
  (state: ICompanyListState) => state
);
